import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EtScreenRecorderComponent } from './et-screen-recorder.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DirectivesModule } from 'src/app/directives/directives.module';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [EtScreenRecorderComponent],
  imports: [
    CommonModule,
    MatTooltipModule,
    IonicModule,
    DirectivesModule,
    TranslateModule
  ],
  exports: [EtScreenRecorderComponent]
})
export class EtScreenRecorderModule { }
